import { DOCUMENT } from '@angular/common';
import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { SettingsService } from '@app/settings.service';
import { UtilService } from '@helpers/util.service';
import { SeoService } from '@shared/services/meta-tags.service';
import { AgentFeedbackService } from '@modules/real-property-agent-details/modules/agent-feedback/services';
import * as userModels from '@modules/user/models';
import * as userServices from '@modules/user/services';
import { MessageService } from 'primeng/api';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { Observable, Subject } from 'rxjs';
import { filter, map, switchMap, takeUntil, tap } from 'rxjs/operators';

// TODO: возможно есть смысл отделить от представления (модалки / раута)
@Component({
  selector: 'app-real-property-agent-profile',
  templateUrl: './real-property-agent-profile.component.html',
  styleUrls: ['./real-property-agent-profile.component.scss'],
  providers: [MessageService],
})
export class RealPropertyAgentProfileComponent implements OnInit, OnDestroy {
  public agent$: Observable<userModels.UserInfo>;
  public chosenRate = 5;
  public commentText: FormControl = new FormControl('');
  public loadingFlag = false;
  public markForUpdate: boolean;
  private destroy$: Subject<void> = new Subject<void>();
  public isMobile: boolean;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private utilService: UtilService,
    private userService: userServices.UserService,
    private dialogRef: DynamicDialogRef,
    private messageService: MessageService,
    private agentFeedbackService: AgentFeedbackService,
    private settingsService: SettingsService,
    private _seoService: SeoService,
    @Inject(DOCUMENT) private document: Document,
  ) {}

  ngOnInit(): void {
    this.settingsService.isMobile().subscribe((isMobile: boolean) => {
      this.isMobile = isMobile;
      this.document.body.style.overflow = !this.isMobile ? 'hidden' : 'auto';
    });
    this.agent$ = this.route.paramMap.pipe(
      filter((params) => params.has('id')),
      map((params) => parseInt(params.get('id'), 10)),
      switchMap((id) => this.userService.getUser(id)),
      tap((user) => {
        const categoryTitle = `Эксперт по недвижимости ${user.name} ${user.surname}, ${user.city ? 'г. ' + user.city : ''}`;
        this.setMetaTags(categoryTitle);
      }),
    );
  }

  setMetaTags(title: string): void {
    this._seoService.setTitle(`${title} ⭐ Витрина Недвижимости`);
    this._seoService.setDescription(`${title} ⭐ Витрина Недвижимости ✅️ Ведущая платформа Казахстана для покупки и продажи недвижимости`);
  }

  public onClose(): void {
    this.dialogRef.close();
    this.router.navigate(['/', this.route.parent.parent.snapshot.data.route, { outlets: { agent: null } }], { queryParamsHandling: 'preserve' }).then();
  }

  public onAddFeedback(id: number): void {
    this.loadingFlag = true;
    this.agentFeedbackService
      .addAgentFeedback({
        agentId: id,
        rating: this.chosenRate,
        comment: this.commentText.value,
      })
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.loadingFlag = false;
        this.commentText.setValue('');
        this.messageService.add({ severity: 'success', summary: 'Отзыв отправлен', life: 1 });
        setTimeout(() => {
          this.messageService.clear();
        }, 3000);
        this.markForUpdate = !this.markForUpdate;
      });
  }

  public getImageUrl(url: string): string {
    const path = this.utilService.getFilePath();
    return path + url;
  }

  public onErrorAvatar(event: Event): void {
    (event.target as HTMLImageElement).src = 'assets/images/User_cicrle_duotone.svg';
    (event.target as HTMLImageElement).classList.add('default-photo');
  }

  public changeRate(event: number): void {
    this.chosenRate = event;
  }

  ngOnDestroy(): void {
    this.document.body.style.overflow = 'auto';
    this.destroy$.next();
    this.destroy$.complete();
  }
}
